export default {
  no_storefront_found: {
    title: 'Storefrontia ei löytynyt',
    description: 'Luo Storefront.',
  },
};
